import { useTranslation } from "react-i18next"
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader"
import DarkCard from "../../../../../../../../components/card/DarkCard"
import LightCard from "../../../../../../../../components/card/LightCard"
import {Link, useParams} from "react-router-dom";
import MenuButtons from "../MenuButtons";
import Error404 from "../../../../../../../Error404";
import React, {useEffect, useState} from "react";
import Rates from "./Rates";
import { Events } from "./Events";
import { TxtTitles } from "../../../../../../../../helpers/breadCrumbs";
import styled from "styled-components";
import { Button } from "../../../../../../../../components/ui/Button";
import { Colors } from "../../../../../../../../components/theme";
import FeedsList from "../../FeedsList";
import { AdditionalProjectCosts } from "./AdditionalProjectCosts";
import {projectCurrent} from "../../../../../../../../services/api/endpoints";
import LoadingData from "../../../../../../../LoadingData";
import TotalEventsCosts from "./TotalEventsCosts";
import useEndpoint from "../../../../../../../../hooks/useEndpiont";
import {calculateTotalCosts, summary_cost} from "./utility";


const TotalPriceStyle = styled.p`
	font-size: 1.5rem;
	font-weight: bold;
	width: 100%;
	@media (max-width: 575px) {
		font-size: 1.8rem;
	}
`;


const SummaryView = () => {
	const params = useParams()
	const { makeRequest, loading, error, reset } = useEndpoint();
	const {t} = useTranslation()
	const [rates, setRates] = useState({})
	const [events, setEvents] = useState([])
	const [events_original, setEvents_original] = useState([])
	const [additional_musicians, setAdditionalMusicians] = useState([])
    const [usersList, setUsersList] = useState([])
	const [late_arrival_fee_deduction, setLate_arrival_fee_deduction] = useState(0.00)
    const [persons_events, setPersonsEvents] = useState([])
	const [total, setTotal] = useState({
		events: {client_cost: 0.00, estro_cost: 0.00, grant_cost: 0.00, total: 0.00},
		total:{client_cost: 0.00, estro_cost: 0.00, grant_cost: 0.00, total: 0.00}
	})
	const [additionalTotalSum, setAdditionalTotalSum] = useState({
		client_cost: 0.00,
		estro_cost: 0.00,
		grant_cost: 0.00,
		total: 0.00
	})

    useEffect(() => {
		const getSummaryData = async () => {
			const data = await makeRequest(projectCurrent.summaryViewData(params.id), "GET");
			if (data) {
				setRates(data.rates)
				setEvents(data.events)
				setEvents_original(data.events)
				setPersonsEvents(data.persons)
				setUsersList(data.users_list)
				setLate_arrival_fee_deduction(data.late_arrival_fee_deduction)
				setAdditionalMusicians(data.additional_musicians)
			}
		}
		getSummaryData()
		return () => reset()
    }, [])

	useEffect(() => {
		const summary_events = summary_cost(events)

		const calculate_additional_cost = calculateTotalCosts(additional_musicians)

		const summary_total = {
			client_cost: calculate_additional_cost.totalClientCost + summary_events.client_cost,
			estro_cost: calculate_additional_cost.totalEstroCost + summary_events.estro_cost,
			grant_cost: calculate_additional_cost.grant_cost + summary_events.grant_cost,
			total: calculate_additional_cost.total + summary_events.total,
		}

		setTotal({total: summary_total, events: summary_events})
	}, [events, additionalTotalSum])

	if (loading) return <LoadingData/>
	if (error) return <Error404/>


	return (<>
		<DarkCard classNames='mb-3 row'>
			<p className="m-0 p-0 breadcrumbs">
				<span className="txt">{t("menu.projects",{ ns: 'menu' })}</span>&#8201;&#9656;&#8201;
				<Link to={'/projects/currents-list'}>{t("menu.current_projects",{ ns: 'menu' })}</Link>&#8201;&#9656;&#8201;
				<Link to={'/projects/current/'+params.id}>{t("breadcrumbs.project_title")} P{params.id}</Link>
			</p>
		</DarkCard>

		<DarkCard classNames='mb-3 row'>
			<TxtTitles>{t("project.project_name_title")}</TxtTitles>
			<h1 className='mb-0 mt-0 p-0' style={{marginTop: '-5px'}}>
				{/*state.dataset.name*/}
			</h1>
			<p className="mt-3 ps-0" style={{fontSize:'14px'}}>
				{t("project.project_id_title")} P{params.id}
			</p>

			<MenuButtons projectId={params.id} active={{summary: "active"}}/>

			<div className='mb-3 mt-5 px-0'>
				<Rates dataSet={rates}/>
			</div>

			<div className='mb-3 mt-3 px-0'>
				<Events
					projectId={params.id}
					events={events}
					setEvents={setEvents}
					events_original={events_original}
					pers={persons_events}
					usersList={usersList}
					late_arrival_fee_deduction={late_arrival_fee_deduction}
				/>
			</div>

			<TotalEventsCosts sumEvents={total.events} t={t} />

			{/* Renting & Transport */}

			{/* Administration & Archiving */}

			{/* Additional musicians costs */}

			{/* Additional project costs */}

			<div className='mb-3 mt-3 px-0'>
					<AdditionalProjectCosts additional_musicians={additional_musicians} setAdditionalTotalSum={setAdditionalTotalSum} />
			</div>

			{/* Total */}
			<LightCard classNames='mb-3 mt-3'>
				<RedHeader title={t("events.summary.total_title")} />
				<div className='row px-2'>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.clients_costs")}</u>
						</p>
						<TotalPriceStyle>
							{total.total.client_cost} €
						</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.estros_costs")}</u>
						</p>
						<TotalPriceStyle>{total.total.estro_cost} €</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.estro_grant")}</u>
						</p>
						<TotalPriceStyle>
							{total.total.grant_cost} €
						</TotalPriceStyle>
					</div>
					<div className='col-sm-3 txtCenter'>
						<p>
							<u>{t("rates.total_costs")}</u>
						</p>
						<TotalPriceStyle>{total.total.total} €</TotalPriceStyle>
					</div>
				</div>
			</LightCard>

			<div className='mb-3 mt-5 px-0'>
				<Button
					className='me-4 pull-right'
					variant='round'
					style={{ backgroundColor: Colors.magenta }}
					name='invoice'
					onClick={() => {}}>
					{t("common.button.create_invoice")}
				</Button>
			</div>
		</DarkCard>

		<DarkCard classNames='mb-3 row'>
			{/* FEED */}
			<FeedsList projectID={params.id}/>
		</DarkCard>
    </>)
}


export default SummaryView

